module.exports = __webpack_public_path__ + "static/icons/icon-holidays-63ed731fe3cca7954d57fb68866d8446.svg";